import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material después de comprar?',
    a: 'El acceso es inmediato. Vas a recibir el material digital luego de confirmar el pago.'
  }, {
    q: '¿Sirve si recién comienzo a ejercer?',
    a: 'Sí. Contarás con modelos, contratos, escritos y fundamentos para abordar tus primeros expedientes con mayor estructura y seguridad.'
  }, {
    q: '¿Sirve si ya tengo experiencia profesional?',
    a: 'Sí. El tratado está pensado para acelerar la redacción, ordenar la búsqueda de antecedentes y sistematizar el trabajo diario del estudio.'
  }, {
    q: '¿Está desarrollado para Argentina?',
    a: 'Sí. El contenido fue diseñado para acompañar la práctica profesional laboral en Argentina y el marco de Modernización Laboral 2026.'
  }, {
    q: '¿La garantía es real?',
    a: 'Sí. Disponés de 7 días para revisar los módulos y bonos. Si el material no cumple tus expectativas, se reintegra el 100% del importe abonado.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="mx-auto max-w-3xl px-5 py-14 md:px-8 md:py-20" data-id="element-59">
      <FadeIn className="text-center" data-id="element-60">
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-61">
          Información de acceso
        </p>
        <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-62">
          Preguntas frecuentes
        </h2>
      </FadeIn>

      <div className="mt-8 space-y-3" data-id="element-63">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <article key={faq.q} className="border border-white/10 bg-charcoal" data-id="element-64">
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-5 px-5 py-4 text-left focus:outline-none focus:ring-2 focus:ring-inset focus:ring-accent" aria-expanded={isOpen} data-id="element-65">
                <span className="font-semibold text-white" data-id="element-66">{faq.q}</span>
                <ChevronDownIcon size={20} className={`shrink-0 text-accent transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-67" />
              </button>
              <AnimatePresence initial={false} data-id="element-68">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: 'easeOut'
            }} data-id="element-69">
                    <p className="border-t border-white/10 px-5 py-4 text-sm leading-relaxed text-stone-400" data-id="element-70">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </article>;
      })}
      </div>
    </section>;
}